module.exports = __webpack_public_path__ + "media/books/Books-Intro-Parents-5bb20580.jpg";